import React from 'react';
import SellerShowcaseCard from './SellerShowcaseCard';

const SellerInfoModal = ({ isOpen, seller, onClose }) => {
  if (!isOpen || !seller) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
      <div className="relative max-h-[90vh] w-full max-w-5xl overflow-y-auto rounded-3xl">
        <button
          type="button"
          className="absolute right-4 top-4 z-10 rounded-full bg-slate-900/85 px-4 py-2 text-sm font-bold text-white shadow-lg"
          onClick={onClose}
        >
          Sulje
        </button>
        <SellerShowcaseCard seller={seller} showMapButton={false} />
      </div>
    </div>
  );
};

export default SellerInfoModal;